import type { IMessage, SendProps } from 'react-native-gifted-chat';

import { Send } from 'react-native-gifted-chat';
import { YStack } from 'tamagui';

import { Icon } from '@south-street-app/atoms';

const ChatSendButton = (props: SendProps<IMessage>) => (
  <Send {...props}>
    <YStack
      alignItems={'center'}
      backgroundColor={'$mono900'}
      borderRadius={'$full'}
      height={'$10'}
      justifyContent={'center'}
      testID={'customer-chat-send-cta'}
      width={'$10'}
    >
      <Icon
        color={'$mono100'}
        iconName={'sendIcon'}
        testID={'customer-chat-send-icon'}
      />
    </YStack>
  </Send>
);

export { ChatSendButton };
